import { Component, EventEmitter, Input, Output } from "@angular/core";
import { HistoryService } from "../services/history.service";
import { Helper } from "src/app/core/helpers/helper";
import { BookingStatus } from "src/app/core/constants/bookingConstant";

@Component({
  selector: "app-ride-list",
  templateUrl: "./ride-list.component.html",
  styleUrl: "./ride-list.component.scss",
  standalone: false
})
export class RideListComponent {
  isDriverLoading: boolean = false;
  @Output() viewDetails = new EventEmitter();
  @Output() rideSearch = new EventEmitter();
  @Input() bookingList: any;
  @Input() isHistoryLoading: any;
  searchText: string = "";

  constructor(private historyService: HistoryService, public helper: Helper) {}

  ngOnInit(): void {}

  /**
   * Emits the selected booking details to the parent component.
   *
   * @param booking The booking object whose details are to be viewed.
   */
  onViewDetails(booking: any): void {
    this.viewDetails.emit(booking);
  }

  /**
   * Adjusts the scrollable height of the table based on the window size.
   * Adds an event listener to handle window resize events.
   */
  ngAfterViewInit(): void {
    setTimeout(() => {
      if (window.innerWidth > 991) {
        this.helper.calculateScorallableHeight();
      }
    }, 500);
    window.addEventListener("resize", ($event: any) => {
      if ($event.target.innerWidth > 991) {
        this.helper.calculateScorallableHeight();
      } else {
        const tableCustomScroll2 = document.querySelector(".custom-scroll-height") as HTMLElement;
        tableCustomScroll2.style.height = "auto";
      }
    });
  }

  /**
   * Emits the search text to the parent component for filtering the ride list.
   */
  onSearch(): void {
    this.rideSearch.emit(this.searchText);
  }

  /**
   * Retrieves the booking type string based on the provided tag.
   *
   * @param tag The tag representing the booking type.
   * @returns The translated booking type string.
   */
  getBookingTypeString(tag: any): string {
    const key = this.helper.BookingTypeString[tag as keyof typeof this.helper.BookingTypeString];
    let string;
    if (key) {
      string = this.helper.translateService.instant(key);
    }
    return string;
  }

  /**
   * Handles the error event for an image element and sets a default image.
   *
   * @param event The error event triggered by the image element.
   */
  handleImageError(event: any): void {
    event.target.src = this.helper.DefaultImages.DefaultUserImage;
  }

  /**
   * Clears the search text and emits an empty string to the parent component.
   */
  clearSearch(): void {
    this.searchText = "";
    this.rideSearch.emit(this.searchText);
  }

  /**
   * Checks if the provided array contains the "SCHEDULE" string and returns the corresponding booking type.
   *
   * @param arr The array of strings to check.
   * @returns The booking type (SCHEDULE or NOW).
   */
  checkSchedule(arr: string[]): number {
    if (arr.includes("SCHEDULE")) {
      return this.helper.BookingType.SCHEDULE;
    }
    return this.helper.BookingType.NOW;
  }

  /**
   * Retrieves the status string based on the provided status code.
   *
   * @param status The status code representing the booking status.
   * @returns The translated status string.
   */
  getStatusString(status: number): string {
    return this.helper.BookingStatusStrings[status as BookingStatus];
  }
}
